import { IFirebaseConfig } from '../../types/app-state'
import { IFirebaseInstance } from '../../types/common'

let firebaseInstance: IFirebaseInstance | null = null

const initializeFirebaseInstance = async (config: IFirebaseConfig) => {
  const {
    FirebaseClient
  } = await import(/* webpackChunkName: "FirebaseClient" */ '../../lib/firebase-client')
  firebaseInstance = new FirebaseClient(config)
}

export { firebaseInstance, initializeFirebaseInstance }
